<div class="dh-column-picker" (shClickOutside)="closeDropdown()">
    <sh-droppanel [isOpen$]="openDropdown$" [inOverflownContainer]="true" [openDirection]="dropdownDirection">
        <div droppanelToggle>
            <sh-action-item [item]="columnSelectButton"></sh-action-item>
        </div>

        @for (group of displayGroups(); track group.id) {
            <div class="dh-column-picker__group" [class.dh-column-picker__group--level]="group.label">
                @if (group.label) {
                    <div class="dh-column-picker__group-header">
                        <input
                            type="checkbox"
                            class="sh-checkbox dh-column-picker__group-toggle"
                            [checked]="true"
                            [disabled]="true"
                            [attr.aria-label]="'column-management.level-toggle' | translate"
                        />
                        <button type="button" class="dh-column-picker__group-title" [attr.aria-expanded]="!group.collapsed" (click)="toggleCollapsed(group.id)">
                            <span>{{ group.label }}</span>
                            <svg
                                sh-icon
                                class="dh-column-picker__group-chevron"
                                [size]="iconSize.SMALL"
                                [name]="group.collapsed ? 'angle-right' : 'angle-down'"
                                aria-hidden="true"
                            ></svg>
                        </button>
                    </div>
                }

                @if (!group.collapsed) {
                    <!-- One drop list per level, deliberately unconnected: a column only reorders inside its own level. -->
                    <ul cdkDropList class="dh-column-picker__list" (cdkDropListDropped)="onDrop(group.id, $event)">
                        @for (item of group.items; track item.key) {
                            <li cdkDrag class="dh-column-picker__item">
                                <span cdkDragHandle class="dh-column-picker__drag-handle" [attr.aria-label]="'column-management.drag-handle' | translate">
                                    @for (dot of [1, 2, 3, 4, 5, 6]; track dot) {
                                        <span class="dh-column-picker__drag-handle__dot"></span>
                                    }
                                </span>
                                <label class="dh-column-picker__label">
                                    <input
                                        type="checkbox"
                                        class="sh-checkbox"
                                        [checked]="item.checked"
                                        [disabled]="item.locked"
                                        (change)="toggleChecked(group.id, item)"
                                    />
                                    <span [class.dh-column-picker__label--checked]="item.checked" [class.dh-column-picker__label--pinned]="item.pinned">{{
                                        item.label
                                    }}</span>
                                </label>
                            </li>
                        }
                    </ul>
                }

                @if (group.showSubfolders !== undefined) {
                    <label class="dh-column-picker__label dh-column-picker__subfolders-toggle">
                        <input
                            type="checkbox"
                            class="sh-checkbox"
                            [checked]="group.showSubfolders"
                            (change)="toggleShowSubfolders(group.id)"
                        />
                        <span>{{ "column-management.show-subfolders" | translate }}</span>
                    </label>
                }
            </div>
        }

        <div footer class="dh-column-picker__footer">
            <button type="button" class="sh-button--secondary" (click)="onReset()">{{ "ui.reset" | translate }}</button>
            <button type="button" class="sh-button" (click)="onSave()">{{ "ui.save" | translate }}</button>
        </div>
    </sh-droppanel>
</div>
